import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

import { RootState } from "..";
import { StorageAreaState } from "../interface/redux-types/StorageAreaState";
import { SetStockpilesAction } from "../interface/redux-types/SetStockpilesAction";
import { SetStockpileAction } from "../interface/redux-types/SetStockpileAction";
import { SetContainmentPadsAction } from "../interface/redux-types/SetContainmentPadsAction";
import { SetContainmentPadAction } from "../interface/redux-types/SetContainmentPadAction";

const initialState: StorageAreaState = {
  stockpiles: [],
  stockpile: null,
  containmentPads: [],
  containmentPad: null,
};

const slice = createSlice({
  name: "storageArea",
  initialState,
  reducers: {
    setStockpiles: (state, action: PayloadAction<SetStockpilesAction>) => {
      state.stockpiles = action.payload.stockpiles;
    },
    setStockpile: (state, action: PayloadAction<SetStockpileAction>) => {
      state.stockpile = action.payload.stockpile;
    },
    clearStockpile: (state) => {
      state.stockpile = null;
    },
    clearStockpiles: (state) => {
      state.stockpiles = [];
    },
    setContainmentPads: (
      state,
      action: PayloadAction<SetContainmentPadsAction>
    ) => {
      state.containmentPads = action.payload.containmentPads;
    },
    setContainmentPad: (
      state,
      action: PayloadAction<SetContainmentPadAction>
    ) => {
      state.containmentPad = action.payload.containmentPad;
    },
    clearContainmentPad: (state) => {
      state.containmentPad = null;
    },
    clearContainmentPads: (state) => {
      state.containmentPads = [];
    },
  },
});

export const {
  setStockpiles,
  setStockpile,
  clearStockpile,
  clearStockpiles,
  setContainmentPads,
  setContainmentPad,
  clearContainmentPad,
  clearContainmentPads,
} = slice.actions;

export const getStockpiles = createSelector(
  (state: RootState) => state.storageAreaStore.stockpiles,
  (stockpiles) => {
    return stockpiles;
  }
);

export const getStockpile = createSelector(
  (state: RootState) => state.storageAreaStore.stockpile,
  (stockpile) => {
    return stockpile;
  }
);

export const getContainmentPads = createSelector(
  (state: RootState) => state.storageAreaStore.containmentPads,
  (containmentPads) => {
    return containmentPads;
  }
);

export const getContainmentPad = createSelector(
  (state: RootState) => state.storageAreaStore.containmentPad,
  (containmentPad) => {
    return containmentPad;
  }
);

export const reducer = slice.reducer;
